import React from "react";

import { Button, Popconfirm } from "antd";

import { DeleteOutlined } from "@ant-design/icons";

import { API_URL } from "../../shared/utils/Util";
import { DeletePointCreditResponse } from "../../types/api";
import { fetchT } from "../../shared/utils/TypedUtil";
import { useNotification } from "../../shared/hooks";

type PointCreditDeleteButtonProps = {
  restaurantId: string;
  id: string;
  on_delete_success: () => void;
};

export const PointCreditDeleteButton = (props: PointCreditDeleteButtonProps) => {
  const { showSuccess, notifyError } = useNotification();
  const [visible, setVisible] = React.useState<boolean>(false);
  const [confirmLoading, setConfirmLoading] = React.useState<boolean>(false);

  const showPopconfirm = () => {
    setVisible(true);
  };

  const handleOk = () => {
    setConfirmLoading(true);

    fetchT<DeletePointCreditResponse>(
      "DELETE",
      `${API_URL}/v1/r/${props.restaurantId}/customer_points/${props.id}`,
      {},
      (result: DeletePointCreditResponse) => {
        props.on_delete_success();

        showSuccess("Deleted points successfully!");

        setConfirmLoading(false);
        setVisible(false);
      },
      (err: any) => {
        setConfirmLoading(false);
        setVisible(false);

        notifyError("Failed to delete points", err);
      }
    );
  };

  const handleCancel = () => {
    setVisible(false);
  };

  return (
    <Popconfirm
      title={`Delete?`}
      open={visible}
      onConfirm={handleOk}
      okButtonProps={{ loading: confirmLoading }}
      onCancel={handleCancel}
    >
      <Button
        icon={<DeleteOutlined />}
        onClick={showPopconfirm}
        style={{ float: "right" }}
        type="primary"
        danger
      >
        Delete
      </Button>
    </Popconfirm>
  );
};
